import { useEffect, useState } from 'react';
import { Box, Button, List, ListItem, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import { DashboardSidebar } from 'components/common';
import { CustomButton, MetaTags } from 'components/common';
import { ApiGet } from 'helpers/Api/ApiData';
import { toast } from 'react-toastify';
import ProfileImg from 'assets/images/profile_img.svg';
// import { useHistory } from 'react-router';
// import { getPaths } from 'components/common/getStatusOfForm';
import { Loader } from 'components/common';
import { useRouter } from 'next/router';
import { useUser } from 'context/user.context';
import { useInvestorRoute } from 'hooks';
import { StartupUpdate } from 'components/v2/StartupUpdate';
// import CommonSwitchDashboard from '../common/CommonSwitchDashboard';
// import CommonDescription from '../common/CommonDescription';

export default function Portfolio() {
  const theme = useTheme();
  const useStyles = makeStyles({
    dashboardWrap: {
      padding: '0',
      display: 'flex',
      flexWrap: 'wrap',
      flexGrow: 1,
      background: 'rgba(239, 255, 250, 0.5)',
      // minHeight: 'calc(100vh - 90px)',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    capitalize: {
      textTransform: 'capitalize',
    },
    dashboardInner: {
      marginLeft: 'auto',
      padding: '40px 66px 0 66px',
      width: 'calc(100% - 200px)',

      [theme.breakpoints.down('sm')]: {
        padding: [[40, 30, 0, 30]],
        width: '100%',
      },

      [theme.breakpoints.down('xs')]: {
        margin: '15px',
        padding: '0px',
        width: '100%',
      },

      '& > h2': {
        display: 'block',
        fontWeight: 'bold',
        fontSize: 24,
        lineHeight: '28px',
        color: '#111111',
        margin: 0,
      },
    },

    tableMain: {
      padding: '62px 33px 0 33px',
      display: 'block',

      [theme.breakpoints.down('lg')]: {
        padding: '40px 0 0 0',
      },
    },
    tableBox: {
      display: 'flex',
      flexWrap: 'wrap',
      background: '#fff',
      boxShadow: '0px 5px 8px rgba(209, 209, 209, 0.25)',
      padding: '30px',
      marginBottom: 45,
      borderRadius: '10px',
    },
    errorColor: {
      background: '#FFFBFB',
    },
    tableHeader: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      alignItems: 'center',
      marginBottom: 40,

      '& button': {
        marginLeft: 'auto',
        cursor: 'auto',
        [theme.breakpoints.down('sm')]: {
          margin: '30px 0 0',
        },

        '& span': {
          textTransform: 'uppercase',

          [theme.breakpoints.down('lg')]: {
            fontSize: 10,
            padding: 0,
          },
        },
      },
    },
    companyName: {
      display: 'flex',
      flexWrap: 'wrap',
      width: 'auto',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },

      '& h3': {
        textTransform: 'capitalize',
        fontWeight: 'bold',
        fontSize: 30,
        lineHeight: '35px',
        color: '#111111',
        margin: 0,
        cursor: 'pointer',

        [theme.breakpoints.down('sm')]: {
          padding: '10px 0px',
          fontSize: 20,
        },
      },
    },
    img: {
      border: '1px solid #C6C6C6',
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
      borderRadius: 5,
      width: 70,
      height: 70,
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 28,
      cursor: 'pointer',
      [theme.breakpoints.down('sm')]: {
        width: 60,
        height: 60,
        marginRight: 10,
      },
      '& img': {
        maxWidth: '100%',
      },
    },

    tableContent: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      padding: 0,
      alignItems: 'flex-start',

      '& > li': {
        width: '19.66666666666667%',
        display: 'block',
        padding: 0,
        [theme.breakpoints.down('sm')]: {
          width: '50%',
        },

        '&:last-child': {
          width: '19.66666666666667%',
        },

        '& h5': {
          display: 'block',
          fontSize: 14,
          color: 'rgba(17, 17, 17, 0.5)',
          lineHeight: '16px',
          marginBottom: 5,
          fontWeight: 400,
        },

        '& ul': {
          padding: 0,
          margin: 0,

          '& > li': {
            padding: 0,
            fontSize: 16,
            lineHeight: '23px',
            color: '#111111',
            marginBottom: 18,
          },
        },
      },
    },
    investmentRecepit: {
      maxWidth: 215,
      background: '#F7FFFC',
      border: '1px solid #77CEB2',
      borderRadius: 10,
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      padding: '12px 20px 12px 12px',
      fontSize: 16,
      color: '#111111',

      '& img': {
        width: 'auto',
        marginRight: 10,
      },
    },
    refundStatusContent: {
      display: 'block',

      '& h6': {
        display: 'block',
        fontSize: 20,
        lineHeight: '23px',
        color: '#111111',
        margin: '0 0 10px 0',
        fontWeight: 400,
      },

      '& p': {
        display: 'block',
        fontSize: 12,
        lineHeight: '14px',
        margin: 0,
        color: 'rgba(17, 17, 17, 0.3)',
      },
    },
    loader: {
      textAlign: 'center',
    },
  });
  const [userData] = useUser();
  const { user: userDetail } = userData;
  const classes = useStyles();
  // const { _id } = Auth.getUserData();
  const router = useRouter();
  useInvestorRoute();
  const [loading, setLoading] = useState<boolean>(true);
  const [investmentDetails, setInvestmentDetails] = useState<any>();

  useEffect(() => {
    // if (getPaths(router)) {
    if (!userDetail) return;
    const { _id } = userDetail;
    // setLoading(true);
    ApiGet(`dashboard/investor/${_id}`)
      .then((res: any) => {
        if (res.data.statusCode === 200) {
          setInvestmentDetails(res.data?.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log('err', err);
        toast.error(err, { autoClose: 5000, hideProgressBar: true });
        setLoading(false);
      });
    // }
  }, [router, userDetail]);

  const getDateInString = (date: string | Date) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dateInIstString = new Date(date);
    const dateInString =
      dateInIstString &&
      dateInIstString.getDate() +
        ' ' +
        months[dateInIstString.getMonth()] +
        ', ' +
        dateInIstString.getFullYear();
    return dateInString;
  };

  const getCampaignStatus = (status: string) => {
    let campaignInformation = {
      name: 'CAMPAIGN ONGOING',
      color: '#FF8F3F',
    };
    switch (status) {
      case 'successful':
        campaignInformation = {
          name: 'CAMPAIGN SUCCESSFUL',
          color: '#48AC4C',
        };
        return campaignInformation;

      case 'ongoing':
        return campaignInformation;

      case 'unsuccessful':
        campaignInformation = {
          name: 'CAMPAIGN UNSUCCESSFUL',
          color: '#F54C4C',
        };
        return campaignInformation;

      default:
        return campaignInformation;
    }
  };

  // const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const addCommas = (num: string | number) =>
    num && Number(num).toLocaleString('en-IN');

  return (
    <>
      <MetaTags
        title="Investment Portfolio - POD"
        description="Portfolio of your investments made on POD"
        imageUrl={`${process.env.NEXT_PUBLIC_FRONTEND_URL}pod-logo.png`}
        url={process.env.NEXT_PUBLIC_FRONTEND_URL!}
        keywords="Startup Fundraising"
      />
      <div className={classes.dashboardWrap}>
        <DashboardSidebar />
        <div className={classes.dashboardInner}>
          <h2>My Investments</h2>
          <div className={classes.tableMain}>
            {!loading ? (
              investmentDetails?.length ? (
                investmentDetails.map((item: any, index: number) => {
                  const { name } = getCampaignStatus(item?.startup_id?.status);
                  return (
                    <div
                      className={
                        name === 'CAMPAIGN UNSUCCESSFUL'
                          ? clsx(classes.tableBox, classes.errorColor)
                          : classes.tableBox
                      }
                      key={index}
                    >
                      <div className={classes.tableHeader}>
                        <div className={classes.companyName}>
                          <div className={classes.img}>
                            <img
                              src={item.startup_id.company_logo || ProfileImg}
                              alt=""
                              onClick={() => {
                                router.push({
                                  pathname: `/startups/${item?.startup_id?.slug_name}`,
                                  // state: item.startup_id._id,
                                });
                              }}
                            />
                          </div>
                          <h3
                            onClick={() => {
                              router.push({
                                pathname: `/startups/${item?.startup_id?.slug_name}`,
                                // state: item.startup_id._id,
                              });
                            }}
                          >
                            {item?.startup_id?.product_name ||
                              item?.startup_id?.company_name}
                          </h3>
                        </div>
                        <CustomButton
                          type="button"
                          // bgColor={color}
                          // bordercolor={color}
                          // fontSize="16"
                          // fontColor="#FFFFFF"
                          // disableRipple
                          // radius="50"
                          // btnPadding="10px 15"
                        >
                          {name}
                        </CustomButton>
                      </div>
                      <List component="ul" className={classes.tableContent}>
                        <ListItem
                        // className={classes.date}
                        >
                          <h5>Investment Date</h5>
                          <List component="ul">
                            <ListItem>
                              {getDateInString(item?.createdAt)}
                            </ListItem>
                          </List>
                        </ListItem>
                        <ListItem
                        // className={classes.amount}
                        >
                          <h5>Investment Amount</h5>
                          <List component="ul">
                            <ListItem>₹{addCommas(item?.amount)}</ListItem>
                          </List>
                        </ListItem>

                        <ListItem>
                          <h5>Document Status</h5>
                          <List component="ul">
                            <ListItem className={classes.capitalize}>
                              {item?.startup_id?.user_id?.document_signed_status
                                ? item?.startup_id?.user_id
                                    ?.document_signed_status
                                : 'pending'}
                            </ListItem>
                          </List>
                        </ListItem>
                      </List>
                      <Box>
                        {!!item?.agreement && (
                          <a
                            href={item.agreement}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Button
                              variant="contained"
                              disableElevation
                              sx={{ textTransform: 'none', mr: 4 }}
                            >
                              Download Agreement
                            </Button>
                          </a>
                        )}
                        {!!item?.instrument && (
                          <a
                            href={item.instrument}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <Button
                              variant="contained"
                              disableElevation
                              sx={{ textTransform: 'none' }}
                            >
                              Download Instrument
                            </Button>
                          </a>
                        )}
                      </Box>
                      {/* {console.log('@@@@@', item)} */}
                      {!!item.startup_id?.updates && (
                        <StartupUpdate updates={item.startup_id.updates} />
                      )}
                    </div>
                  );
                })
              ) : (
                'You have not made any investments yet. View promising startups and start investing.'
              )
            ) : (
              <div>
                <Loader />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <CommonSwitchDashboard/> */}
    </>
  );
}
